import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
// import './disableConsole'; // DISABLED: Re-enabling console for debugging
import App from './App';
import PrivacyPage from './pages/PrivacyPage';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const isPrivacyPage = window.location.pathname === '/privacy';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isPrivacyPage ? (
      <PrivacyPage />
    ) : (
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster position="top-right" />
      </QueryClientProvider>
    )}
  </React.StrictMode>
);

